import { FormattedMessage } from 'react-intl';
import { Outlet, generatePath, useParams } from 'react-router-dom';

import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import {
  MLB_SCOUTING_CENTER_GAMES_GAMEID_BOX_SCORE,
  MLB_SCOUTING_CENTER_GAMES_GAMEID_PLAYERS,
} from '@sorare/core/src/constants/__generated__/routes';
import { glossary } from '@sorare/core/src/lib/glossary';

const tabs = [
  {
    label: glossary.boxScore,
    to: MLB_SCOUTING_CENTER_GAMES_GAMEID_BOX_SCORE,
    matches: [MLB_SCOUTING_CENTER_GAMES_GAMEID_BOX_SCORE],
  },
  {
    label: glossary.players,
    to: MLB_SCOUTING_CENTER_GAMES_GAMEID_PLAYERS,
    matches: [MLB_SCOUTING_CENTER_GAMES_GAMEID_PLAYERS],
  },
];

const ScoutingCenterGameIdLayout = () => {
  const { gameId } = useParams();

  return (
    <ContentWithStickyHeader
      header={
        <TabBar variant="flat" fullWidth ignoreQueryParams>
          {tabs.map(({ label, to, matches }) => (
            <Tab
              key={label.id}
              matches={matches}
              to={generatePath(to, { gameId })}
            >
              <FormattedMessage {...label} />
            </Tab>
          ))}
        </TabBar>
      }
    >
      <Outlet />
    </ContentWithStickyHeader>
  );
};

export default ScoutingCenterGameIdLayout;
